import React, { useContext } from 'react';
import { IoIosArrowRoundBack, IoIosArrowRoundForward } from 'react-icons/io';
import { DESKTOP } from '_utils/constant';
import { DeviceUserContext } from '_context/DeviceUserContext';
import './style.scss';

export default function ButtonNavigation({
  currentStep = 1,
  onCancel,
  onNext,
  // onSaveDraft,
  disabledCancel = false,
  disabledNext = false,
  // disabledSaveDraft = false,
  className = '',
}) {
  const { checkDeviceUser } = useContext(DeviceUserContext) || {};
  const isDesktop = checkDeviceUser === DESKTOP;

  const renderCancelText = currentStep > 1 ? 'Back' : 'Cancel';
  const renderNextText = currentStep === 3 ? 'Publish' : 'Next';

  return (
    <div
      className={`button-navigation ${isDesktop ? 'is-desktop' : ''} ${
        currentStep === 3 ? 'step-3' : ''
      } ${className}`.trim()}
    >
      <div className="button-navigation-main">
        <button
          type="button"
          className="btn-navigation button-cancel"
          onClick={onCancel}
          disabled={disabledCancel}
        >
          {currentStep > 1 && <IoIosArrowRoundBack size={18} style={{ marginRight: '2px' }} />}
          {renderCancelText}
        </button>
        <button
          type="button"
          className="btn-navigation button-next"
          onClick={onNext}
          disabled={disabledNext}
        >
          {renderNextText}
          <IoIosArrowRoundForward size={18} style={{ marginLeft: '2px' }} />
        </button>
      </div>

      {/* {currentStep === 3 && (
        <button
          type="button"
          className="btn-navigation button-draft"
          onClick={onSaveDraft}
          disabled={disabledSaveDraft}
        >
          Save as draft
        </button>
      )} */}
    </div>
  );
}
